import {
    CancelOutlined as CancelOutlinedIcon,
    CheckCircleOutlined as CheckCircleOutlinedIcon
} from '@material-ui/icons';
import {
    Box,
    Button,
    CardContent,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormGroup,
    FormLabel,
    InputLabel,
    Select,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    appendFieldsToFormData,
    formatCurrency,
    formatDateForInput,
    getCodUsuarioRegistrou,
    validateField
} from 'lib/functions';
import api from '../../../services/api';
import React, { Component } from 'react';
import { validateComboFields } from 'lib/configUtils';
import ComboPadrao from 'views/Components/ComboPadrao';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { AABASTECIMENTO_EXTERNO, AABASTECIMENTO_INTERNO } from '../../../consts';

class AbastecimentoForm extends Component {
    state = {
        abastecimento: {
            codabastecimento: '',
            codveiculo: '',
            codfuncionario: '',
            codcategoriacombustivel: '',
            codcombustivel: '',
            data: '',
            codprojeto: '',
            tipoabastecimento: '',
            descricao: '',
            volumeabastecimento: '',
            valor: '',
            precoporlitro: '',
            kmatual: '',
            nronf: '',
            codpostocombustivel: '',
            codbomba: '',
            hora: '',
            kmspercorridoabastecimento: '',
            consumoabastecimento: '',
            origem: '',
            listacp: ''
        },
        errors: {},
        errorsModal: {},
        veiculos: [],
        motoristas: [],
        categoriascombustivel: [],
        combustiveis: [],
        projetos: [],
        postos: [],
        bombas: [],
        isNewRecord: false,
        isView: false,
        openAlert: false,
        messageAlert: '',
        openMotivoModal: false,
        schema: {
            data: {
                presence: { allowEmpty: false, message: 'Data obrigatória' },
                length: { maximum: 10 },
                type: 'date'
            },
            codveiculo: {
                presence: { allowEmpty: false, message: 'Veículo obrigatório' },
                length: { maximum: 100 },
                type: 'integer'
            },
            kmatual: {
                presence: { allowEmpty: false, message: 'Hodômetro inválido' },
                length: { maximum: 100 },
                type: 'integer'
            },
            volumeabastecimento: {
                presence: { allowEmpty: false, message: 'Volume obrigatório' },
                length: { maximum: 100 },
                type: 'number'
            },
            valor: {
                presence: { allowEmpty: false, message: 'Valor total obrigatório' },
                length: { maximum: 100 },
                type: 'number'
            },
            codfuncionario: {
                presence: { allowEmpty: false, message: 'Motorista obrigatório' },
                length: { maximum: 100 },
                type: 'integer'
            },
            codcombustivel: {
                presence: { allowEmpty: false, message: 'Combustível obrigatório' },
                length: { maximum: 100 },
                type: 'integer'
            },
            codcategoriacombustivel: {
                presence: { allowEmpty: false, message: 'Categoria de combustível obrigatória' },
                length: { maximum: 100 },
                type: 'integer'
            },
            codpostocombustivel: {
                presence: { allowEmpty: false, message: 'Posto de combustível obrigatório' },
                length: { maximum: 100 },
                type: 'integer'
            },
            codbomba: {
                presence: { allowEmpty: false, message: 'Bomba interna obrigatória' },
                length: { maximum: 100 },
                type: 'integer'
            },
            descricao: {
                presence: { allowEmpty: false, message: 'Descrição motivo abastecimento obrigatória' },
                length: { maximum: 5000 },
                type: 'string'
            }
        }
    };

    /* Altera a cor do ícone de confirmação ao passar o cursor */
    handleConfirmIconMouseEnter = (event) => {
        event.currentTarget.style.color = '#32860e';
    };

    /* Retorna à cor padrão do ícone de confirmação ao remover o cursor */
    handleConfirmIconMouseLeave = (event) => {
        event.currentTarget.style.color = '#43b811';
    };

    /* Altera a cor do ícone de cancelamento ao passar o cursor */
    handleCancelIconMouseEnter = (event) => {
        event.currentTarget.style.color = '#c20000';
    };

    /* Retorna à cor padrão do ícone de cancelamento ao remover o cursor */
    handleCancelIconMouseLeave = (event) => {
        event.currentTarget.style.color = 'red';
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;
        const isView = location.pathname.includes('/view');

        try {
            await this.loadCombosDefault();

            if (!isNaN(Number(id))) {
                await this.loadAbastecimento(id, isView);
            } else if (id === 'novo') {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    abastecimento: this.getAbastecimentoDefault()
                });
            }
        } catch (error) {
            console.error('Erro ao carregar abastecimento:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar abastecimento!'
            );
        }
    };

    /* Retorna o abastecimento padrão */
    getAbastecimentoDefault = () => ({
        codabastecimento: '',
        codveiculo: '',
        codfuncionario: '',
        codcategoriacombustivel: '',
        codcombustivel: '',
        data: '',
        codprojeto: '',
        tipoabastecimento: AABASTECIMENTO_EXTERNO,
        descricao: '',
        volumeabastecimento: '',
        valor: '',
        precoporlitro: '',
        kmatual: 0,
        nronf: '',
        codpostocombustivel: '',
        codbomba: '',
        hora: '',
        kmspercorridoabastecimento: '',
        consumoabastecimento: '',
        origem: '',
        listacp: ''
    });

    /* Carrega os dados dos combos */
    loadCombosDefault = async () => {
        const paramsVeiculo = '?page=1&limit=500&veiculoproprio=S';
        const paramsMotorista = '?page=1&limit=500&funcionario=S';
        const paramsPosto = '?page=1&limit=500&postocombustivel=S';

        const [
            veiculos,
            motoristas,
            postos,
            categoriascombustivel,
            combustiveis,
            projetos,
            bombas
        ] = await Promise.all([
            api.get(`/veiculo/active/true${paramsVeiculo}`),
            api.get(`/fornecedor/active/true${paramsMotorista}`),
            api.get(`/fornecedor/active/true${paramsPosto}`),
            api.get('/categoriacombustivel/active/true'),
            api.get('/combustivel/active/true'),
            api.get('/financas/projeto/active/true'),
            api.get('/bomba/active/true')
        ]);

        this.setState({
            veiculos: this.formatVeiculos(veiculos.data?.data || []),
            motoristas: motoristas.data,
            postos: postos.data,
            categoriascombustivel: categoriascombustivel.data,
            combustiveis: combustiveis.data,
            projetos: projetos.data,
            bombas: bombas.data?.data || bombas.data || []
        });
    };

    /* Formata os veículos para a exibição */
    formatVeiculos = (veiculos) => (
        (veiculos || []).map(item => ({
            ...item,
            placanroveiculo: item.placa && item.nroveiculo
                ? `${item.placa} [${item.nroveiculo}]`
                : (item.nroveiculo || '')
        }))
    );

    /* Carrega o abastecimento */
    loadAbastecimento = async (id, isView) => {
        const response = await api.get(`/abastecimento/${id}`);
        const dados = response?.data?.data?.[0] || {};

        const [
            categoriascombustivel,
            combustiveis,
            projetos,
            bombas
        ] = await Promise.all([
            api.get(`/categoriacombustivel/listforchange/${dados.codcategoriacombustivel}`),
            api.get(`/combustivel/listforchange/${dados.codcombustivel}`),
            api.get(`/financas/projeto/listforchange/${dados.codprojeto}`),
            api.get(`/bomba/listforchange/${dados.codbomba}`)
        ]);

        this.setState({
            categoriascombustivel: categoriascombustivel.data,
            combustiveis: combustiveis.data,
            projetos: projetos.data,
            bombas: bombas.data,
            abastecimento: {
                ...dados,
                data: dados.data ? formatDateForInput(dados.data) : '',
                tipoabastecimento: String(dados.tipoabastecimento || AABASTECIMENTO_EXTERNO),
                descricao: dados.descricao || '',
                kmatual: dados.kmatual === undefined ? null : dados.kmatual
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = async (event) => {
        const { name, value, type, checked } = event.target;

        this.setState(prevState => {
            const novo = {
                ...prevState.abastecimento,
                [name]: type === 'checkbox' ? checked : value
            };

            // preenche automaticamente o combustível vinculado ao veículo
            if (name === 'codveiculo') {
                const veiculoSelecionado = prevState.veiculos.find(
                    item => String(item.codveiculo) === String(value)
                );

                if (veiculoSelecionado && veiculoSelecionado.codcombustivel) {
                    novo.codcombustivel = veiculoSelecionado.codcombustivel;
                } else {
                    novo.codcombustivel = '';
                }

                if (veiculoSelecionado && veiculoSelecionado.codprojeto) {
                    novo.codprojeto = veiculoSelecionado.codprojeto;
                } else {
                    novo.codprojeto = '';
                }
            }

            // troca o tipo de abastecimento
            if (name === 'tipoabastecimento') {
                if (value === AABASTECIMENTO_EXTERNO) {
                    novo.codbomba = '';
                }

                if (value === AABASTECIMENTO_INTERNO) {
                    novo.codpostocombustivel = '';
                }
            }

            // calcula o preço por litro
            const volume = parseFloat(novo.volumeabastecimento);
            const valorTotal = parseFloat(novo.valor);

            if (!isNaN(volume) && !isNaN(valorTotal) && volume > 0 && valorTotal > 0) {
                novo.precoporlitro = (valorTotal / volume).toFixed(2);
            } else {
                novo.precoporlitro = '';
            }

            return { abastecimento: novo };
        });

        if (name === 'tipoabastecimento' && value === AABASTECIMENTO_INTERNO) {
            const response = await api.get('/bomba/active/true');
            const lista = response.data?.data || response.data || [];

            this.setState({ bombas: lista });
        }
    };

    /* Abre o modal de motivo de abastecimento */
    handleOpenMotivoModal = () => {
        this.setState({
            openMotivoModal: true,
            errorsModal: {}
        });
    };

    /* Fecha o modal de motivo de abastecimento */
    handleCloseMotivoModal = () => {
        this.setState({
            openMotivoModal: false,
            errorsModal: {}
        });
    };

    /* Muda a descrição do motivo de abastecimento */
    handleChangeDescricaoMotivo = (event) => {
        const { value } = event.target;

        this.setState(prev => ({
            abastecimento: {
                ...prev.abastecimento,
                descricao: value
            },
            errorsModal: {
                ...prev.errorsModal,
                descricao: ''
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { abastecimento, isNewRecord } = this.state;

        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        const comboErrors = validateComboFields(abastecimento, [
            {
                field: 'codveiculo',
                message: 'Selecione um veículo válido'
            },
            {
                field: 'codfuncionario',
                message: 'Selecione um motorista válido'
            },
            {
                field: 'codcategoriacombustivel',
                message: 'Selecione uma categoria de combustível válida'
            },
            {
                field: 'codcombustivel',
                message: 'Selecione um combustível válido'
            },
            ...(abastecimento.tipoabastecimento === AABASTECIMENTO_EXTERNO
                ? [{
                    field: 'codpostocombustivel',
                    message: 'Selecione um posto de combustível válido'
                }]
                : []),
            ...(abastecimento.tipoabastecimento === AABASTECIMENTO_INTERNO
                ? [{
                    field: 'codbomba',
                    message: 'Selecione uma bomba interna válida'
                }]
                : [])
        ]);

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione registros válidos nos campos indicados em vermelho!');

            return;
        }

        if (isNewRecord) {
            this.handleOpenMotivoModal();

            return;
        }

        await this.handleSubmitAbastecimento();
    };

    /* Confirma o motivo do abastecimento */
    handleConfirmMotivoModal = async () => {
        const { abastecimento, schema } = this.state;
        const descricaoError = validateField('descricao', abastecimento.descricao, schema);

        if (descricaoError) {
            this.setState({
                errorsModal: {
                    descricao: descricaoError
                }
            });

            return;
        }

        this.setState({
            openMotivoModal: false,
            errorsModal: {}
        });

        await this.handleSubmitAbastecimento();
    };

    /* Retorna o payload do abastecimento */
    getPayloadAbastecimento = () => {
        const { abastecimento, isNewRecord } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();

        if (!codusuarioregistrou) {
            throw new Error('Código do usuário não encontrado!');
        }

        const fields = {
            data: abastecimento.data || '',
            valor: abastecimento.valor || '',
            kmatual: abastecimento.kmatual || '',
            codusuarioregistrou: Number(codusuarioregistrou),
            codveiculo: abastecimento.codveiculo || '',
            volumeabastecimento: abastecimento.volumeabastecimento || '',
            codfuncionario: abastecimento.codfuncionario || '',
            codcombustivel: abastecimento.codcombustivel || '',
            codbomba: abastecimento.codbomba || '',
            codcategoriacombustivel: abastecimento.codcategoriacombustivel || '',
            tipoabastecimento: abastecimento.tipoabastecimento || '',
            hora: abastecimento.hora || '',
            codpostocombustivel: abastecimento.codpostocombustivel || '',
            nronf: abastecimento.nronf || '',
            precoporlitro: abastecimento.precoporlitro || '',
            kmspercorridoabastecimento: abastecimento.kmspercorridoabastecimento || '',
            consumoabastecimento: abastecimento.consumoabastecimento || '',
            origem: abastecimento.origem || '',
            codprojeto: abastecimento.codprojeto || '',
            listacp: abastecimento.listacp || ''
        };

        if (isNewRecord) {
            fields.descricao = abastecimento.descricao || '';
        }

        return appendFieldsToFormData(fields);
    };

    /* Clicar para enviar */
    handleSubmitAbastecimento = async () => {
        const { abastecimento, isNewRecord } = this.state;
        const { history } = this.props;

        try {
            const formData = this.getPayloadAbastecimento();

            if (isNewRecord) {
                await api.post('/abastecimento', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                await api.put(`/abastecimento/${abastecimento.codabastecimento}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            history.push('/frotas/abastecimento');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.message ||
                'Erro ao salvar!'
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/abastecimento');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { abastecimento, schema } = this.state;
        let errors = {};

        // valida os campos do schema
        const requiredFields = [
            'data',
            'codveiculo',
            'kmatual',
            'volumeabastecimento',
            'valor',
            'codfuncionario',
            'codcombustivel',
            'codcategoriacombustivel'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, abastecimento[field], schema);

            if (error) {
                errors[field] = error;
            }
        });

        // valida se o hodômetro é válido
        if (abastecimento.kmatual === 0 || abastecimento.kmatual === '0') {
            errors.kmatual = 'Hodômetro inválido';
        }

        // valida apenas o campo relacionado ao tipo de abastecimento
        if (abastecimento.tipoabastecimento == AABASTECIMENTO_INTERNO) {
            const codbombaError = validateField('codbomba', abastecimento.codbomba, schema);

            if (codbombaError) {
                errors.codbomba = 'Bomba interna obrigatória';
            }
        }

        if (abastecimento.tipoabastecimento == AABASTECIMENTO_EXTERNO) {
            const codpostocombustivelError = validateField(
                'codpostocombustivel',
                abastecimento.codpostocombustivel,
                schema
            );

            if (codpostocombustivelError) {
                errors.codpostocombustivel = 'Posto de combustível obrigatório';
            }
        }

        return errors;
    };

    /* Trata os campos com vírgula */
    handleChangeValorMonetario = (e, campo) => {
        const raw = e.target.value;
        const semFormatacao = raw.replace(/[^\d,]/g, '');
        const numero = parseFloat(semFormatacao.replace(',', '.'));

        this.setState(prevState => {
            const novo = {
                ...prevState.abastecimento,
                [campo]: !isNaN(numero) ? numero : ''
            };

            const volume = parseFloat(novo.volumeabastecimento);
            const valorTotal = parseFloat(novo.valor);

            if (!isNaN(volume) && !isNaN(valorTotal) && volume > 0 && valorTotal > 0) {
                novo.precoporlitro = (valorTotal / volume).toFixed(2);
            } else {
                novo.precoporlitro = '';
            }

            return { abastecimento: novo };
        });
    };

    /* Aceitar somente dígitos */
    handleNumericChange = (e) => {
        const { name, value } = e.target;
        const onlyDigits = value.replace(/\D/g, '');

        this.setState(prev => ({
            abastecimento: { ...prev.abastecimento, [name]: onlyDigits }
        }));
    };

    render() {
        const {
            abastecimento,
            bombas,
            categoriascombustivel,
            combustiveis,
            errors,
            errorsModal,
            isView,
            messageAlert,
            motoristas,
            openAlert,
            openMotivoModal,
            postos,
            projetos,
            veiculos
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{
                            flexWrap: 'wrap',
                            gap: 12
                        }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Abastecimento {abastecimento.codabastecimento}
                        </Typography>
                    </Box>

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{
                            gap: 12,
                            marginTop: 10
                        }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: '0 1 260px',
                                minWidth: 260
                            }}
                        >
                            <ComboPadrao
                                name={'codveiculo'}
                                label={'Veículo'}
                                value={abastecimento.codveiculo}
                                onChange={this.onChange}
                                fieldId={'codveiculo'}
                                listItems={veiculos}
                                fieldDescription={'placanroveiculo'}
                                helperText={errors.codveiculo || ''}
                                error={!!errors.codveiculo}
                            />
                        </FormControl>

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: '0 1 420px',
                                minWidth: 300
                            }}
                        >
                            <ComboPadrao
                                name={'codfuncionario'}
                                label={'Motorista'}
                                value={abastecimento.codfuncionario}
                                onChange={this.onChange}
                                fieldId={'codfornecedor'}
                                listItems={motoristas}
                                fieldDescription={'descfornecedor'}
                                helperText={errors.codfuncionario || ''}
                                error={!!errors.codfuncionario}
                            />
                        </FormControl>
                    </Box>

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{
                            gap: 12,
                            marginTop: 10
                        }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: '0 1 320px',
                                minWidth: 300
                            }}
                        >
                            <ComboPadrao
                                name={'codcategoriacombustivel'}
                                label={'Categoria de Combustível'}
                                value={abastecimento.codcategoriacombustivel}
                                onChange={this.onChange}
                                fieldId={'codcategoriacombustivel'}
                                listItems={categoriascombustivel}
                                fieldDescription={'desccategoriacombustivel'}
                                helperText={errors.codcategoriacombustivel || ''}
                                error={!!errors.codcategoriacombustivel}
                            />
                        </FormControl>

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: '0 1 300px',
                                minWidth: 260
                            }}
                        >
                            <ComboPadrao
                                name={'codcombustivel'}
                                label={'Combustível'}
                                value={abastecimento.codcombustivel}
                                onChange={this.onChange}
                                fieldId={'codcombustivel'}
                                listItems={combustiveis}
                                fieldDescription={'desccombustivel'}
                                helperText={errors.codcombustivel || ''}
                                error={!!errors.codcombustivel}
                            />
                        </FormControl>
                    </Box>

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{
                            gap: 12,
                            marginTop: 10
                        }}
                    >
                        <TextField
                            label="Data"
                            name="data"
                            onChange={this.onChange}
                            type="date"
                            value={abastecimento.data || ''}
                            variant="outlined"
                            disabled={isView}
                            helperText={errors.data || ''}
                            error={!!errors.data}
                            InputLabelProps={{
                                shrink: true,
                                required: false
                            }}
                            style={{
                                flex: '0 1 180px',
                                minWidth: 180
                            }}
                        />

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: '0 1 420px',
                                minWidth: 300
                            }}
                        >
                            <ComboPadrao
                                name={'codprojeto'}
                                label={'Projeto'}
                                value={abastecimento.codprojeto}
                                onChange={this.onChange}
                                fieldId={'codprojeto'}
                                listItems={projetos}
                                fieldDescription={'descprojeto'}
                            />
                        </FormControl>
                    </Box>

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{
                            gap: 12,
                            marginTop: 10
                        }}
                    >
                        <FormControl
                            variant="filled"
                            disabled={isView}
                            style={{
                                flex: '0 1 240px',
                                minWidth: 240
                            }}
                        >
                            <InputLabel
                                htmlFor="outlined-age-native-simple"
                                shrink={true}
                                style={{ padding: '0 4px' }}
                            >
                                Tipo Abastecimento
                            </InputLabel>

                            <Select
                                label="Tipo Abastecimento"
                                native
                                onChange={this.onChange}
                                value={abastecimento.tipoabastecimento}
                                inputProps={{
                                    id: 'outlined-age-native-simple',
                                    name: 'tipoabastecimento'
                                }}
                            >
                                <option
                                    key={AABASTECIMENTO_EXTERNO}
                                    value={AABASTECIMENTO_EXTERNO}
                                >
                                    {"Externo"}
                                </option>

                                <option
                                    key={AABASTECIMENTO_INTERNO}
                                    value={AABASTECIMENTO_INTERNO}
                                >
                                    {"Interno"}
                                </option>
                            </Select>
                        </FormControl>

                        {abastecimento.tipoabastecimento == AABASTECIMENTO_EXTERNO && (
                            <FormControl
                                variant="outlined"
                                disabled={isView}
                                style={{
                                    flex: '0 1 420px',
                                    minWidth: 300,
                                    transition: 'all 0.3s ease-in-out'
                                }}
                            >
                                <ComboPadrao
                                    name={'codpostocombustivel'}
                                    label={'Posto de Combustível'}
                                    value={abastecimento.codpostocombustivel}
                                    onChange={this.onChange}
                                    fieldId={'codfornecedor'}
                                    listItems={postos}
                                    fieldDescription={'descfornecedor'}
                                    helperText={errors.codpostocombustivel || ''}
                                    error={!!errors.codpostocombustivel}
                                />
                            </FormControl>
                        )}

                        {abastecimento.tipoabastecimento == AABASTECIMENTO_INTERNO && (
                            <FormControl
                                variant="outlined"
                                disabled={isView}
                                style={{
                                    flex: '0 1 420px',
                                    minWidth: 300,
                                    transition: 'all 0.3s ease-in-out'
                                }}
                            >
                                <ComboPadrao
                                    name={'codbomba'}
                                    label={'Bomba Interna'}
                                    value={abastecimento.codbomba}
                                    onChange={this.onChange}
                                    fieldId={'codbomba'}
                                    listItems={bombas}
                                    fieldDescription={'descbomba'}
                                    helperText={errors.codbomba || ''}
                                    error={!!errors.codbomba}
                                />
                            </FormControl>
                        )}
                    </Box>

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{
                            gap: 12,
                            marginTop: 10
                        }}
                    >
                        <TextField
                            label="Volume"
                            name="volumeabastecimento"
                            value={abastecimento.volumeabastecimento !== '' &&
                                abastecimento.volumeabastecimento !== null &&
                                abastecimento.volumeabastecimento !== undefined ? formatCurrency(
                                    abastecimento.volumeabastecimento
                                ) : '0,00'
                            }
                            variant="outlined"
                            onChange={(e) => this.handleChangeValorMonetario(e, 'volumeabastecimento')}
                            disabled={isView}
                            type="text"
                            helperText={errors.volumeabastecimento || ''}
                            error={!!errors.volumeabastecimento}
                            style={{
                                flex: '0 1 180px',
                                minWidth: 180
                            }}
                        />

                        <TextField
                            label="Valor Litro"
                            name="precoporlitro"
                            value={abastecimento.precoporlitro !== '' &&
                                abastecimento.precoporlitro !== null &&
                                abastecimento.precoporlitro !== undefined ? formatCurrency(
                                    abastecimento.precoporlitro
                                ) : '0,00'
                            }
                            variant="outlined"
                            disabled
                            type="text"
                            style={{
                                flex: '0 1 180px',
                                minWidth: 180
                            }}
                        />

                        <TextField
                            label="Valor Total"
                            name="valor"
                            value={abastecimento.valor !== '' &&
                                abastecimento.valor !== null &&
                                abastecimento.valor !== undefined ? formatCurrency(
                                    abastecimento.valor
                                ) : '0,00'
                            }
                            variant="outlined"
                            onChange={(e) => this.handleChangeValorMonetario(e, 'valor')}
                            disabled={isView}
                            type="text"
                            helperText={errors.valor || ''}
                            error={!!errors.valor}
                            style={{
                                flex: '0 1 180px',
                                minWidth: 180
                            }}
                        />
                    </Box>

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{
                            gap: 12,
                            marginTop: 10
                        }}
                    >
                        <TextField
                            label="Hodômetro (km rodados)"
                            name="kmatual"
                            value={abastecimento.kmatual !== '' &&
                                abastecimento.kmatual !== null &&
                                abastecimento.kmatual !== undefined ? abastecimento.kmatual : ''
                            }
                            variant="outlined"
                            onChange={this.handleNumericChange}
                            disabled={isView}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6 }}
                            helperText={errors.kmatual || ''}
                            error={!!errors.kmatual}
                            style={{
                                flex: '0 1 260px',
                                minWidth: 240
                            }}
                        />

                        <TextField
                            label="Número Nota Fiscal"
                            name="nronf"
                            value={abastecimento.nronf || ''}
                            variant="outlined"
                            onChange={this.handleNumericChange}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{
                                flex: '0 1 260px',
                                minWidth: 240,
                                display: (abastecimento.tipoabastecimento == AABASTECIMENTO_EXTERNO) ? '' : 'none',
                                transition: 'opacity 0.3s ease-in-out'
                            }}
                        />
                    </Box>

                    <br />
                    <br />

                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />

                <Dialog
                    open={openMotivoModal}
                    onClose={this.handleCloseMotivoModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>Motivo Abastecimento</DialogTitle>

                    <DialogContent style={{ paddingBottom: 24 }}>
                        <FormGroup style={{ marginBottom: 12 }}>
                            <FormLabel
                                component="legend"
                                style={{
                                    fontSize: 14,
                                    marginBottom: 8,
                                    color: errorsModal.descricao ? '#f44336' : '#616161'
                                }}
                            >
                                Descrição motivo
                            </FormLabel>

                            <textarea
                                id="descricao"
                                name="descricao"
                                value={abastecimento.descricao || ''}
                                onChange={this.handleChangeDescricaoMotivo}
                                style={{
                                    height: 140,
                                    width: '100%',
                                    padding: 12,
                                    border: errorsModal.descricao ? '1px solid #f44336' : '1px solid #cccccc',
                                    borderRadius: 6,
                                    fontFamily: 'Calibri, sans-serif',
                                    resize: 'none',
                                    outline: 'none'
                                }}
                            />

                            {errorsModal.descricao && (
                                <Typography
                                    variant="caption"
                                    style={{
                                        color: '#f44336',
                                        marginTop: 4,
                                        marginLeft: 2
                                    }}
                                >
                                    {errorsModal.descricao}
                                </Typography>
                            )}
                        </FormGroup>

                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="center"
                            style={{ gap: 16 }}
                        >
                            <Tooltip title="OK">
                                <CheckCircleOutlinedIcon
                                    onMouseEnter={this.handleConfirmIconMouseEnter}
                                    onMouseLeave={this.handleConfirmIconMouseLeave}
                                    onClick={this.handleConfirmMotivoModal}
                                    style={{
                                        cursor: 'pointer',
                                        color: '#43b811'
                                    }}
                                />
                            </Tooltip>

                            <Tooltip title="Fechar">
                                <CancelOutlinedIcon
                                    onMouseEnter={this.handleCancelIconMouseEnter}
                                    onMouseLeave={this.handleCancelIconMouseLeave}
                                    onClick={this.handleCloseMotivoModal}
                                    style={{
                                        cursor: 'pointer',
                                        color: 'red'
                                    }}
                                />
                            </Tooltip>
                        </Box>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

export default AbastecimentoForm;